import { API_URL, DEFAULT_CKEY, getInitializedMomentFetcher, } from '@moment/net/fetch-contstants.ts';
import { i18n, resolvedLanguage } from '@/i18n.ts';

export const HOROSCOPES_SCHEDULE = {} as Record<string, string>;
HOROSCOPES_SCHEDULE.general = 'horoscopes-general';
HOROSCOPES_SCHEDULE.love = 'horoscopes-love';
HOROSCOPES_SCHEDULE.money = 'horoscopes-money';
HOROSCOPES_SCHEDULE.health = 'horoscopes-health';

// Define granular query keys for horoscopes of different categories
export const HOROSCOPES_QUERY_KEYS = {
  schedule: (scheduleId: string) => {
    return ['horoscopes', scheduleId];
  },
};

export const fetchHoroscopes = async (lang?: string, schedule?: string) => {
  const resolvedSchedule = schedule || HOROSCOPES_SCHEDULE.general;
  try {
    let language = lang || resolvedLanguage('en');
    // Softbox API only supports English and Spanish, default back to English since API does not fallback
    language = ['en', 'es'].includes(language) ? language : 'en';
    const momentFetcher = await getInitializedMomentFetcher();
    const url = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&mp_lang=${language}&sched=${resolvedSchedule}`;
    const response = await momentFetcher.fetch(url);
    const rawHoroscopes = await response.json();
    return rawHoroscopes;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Generate prefetch queries for all horoscope categories
export const genFetchHoroscopesQuery = (params?: { lang?: string }) => {
  const language = params?.lang || resolvedLanguage('en');
  const queryDefinitions = [];

  // Loop through all four horoscope categories and create prefetch queries
  for (const schedule of Object.values(HOROSCOPES_SCHEDULE)) {
    queryDefinitions.push({
      queryKey: HOROSCOPES_QUERY_KEYS.schedule(schedule),
      queryFn: () => {
        return fetchHoroscopes(language, schedule);
      },
    });
  }

  return queryDefinitions;
};
